import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '企微主体',
      filterable: true,
      clearable: true,
      placeholder: '请选择主体'
    },
    {
      field: 'empId',
      type: 'input',
      label: '企微账号',
      clearable: true,
      placeholder: '请输入企微账号'
    },
    {
      field: 'userName',
      type: 'input',
      label: '客户昵称',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      field: 'userId',
      type: 'input',
      label: '客户ID',
      clearable: true,
      placeholder: '请输入客户ID'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'tag',
      type: 'input',
      label: '标签名称',
      clearable: true,
      placeholder: '请输入标签名称'
    },
    {
      field: 'slotTime',
      type: 'dateTimePicker',
      label: '删除时间',
      clearable: false,
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return date.getTime() < new Date('2026-06-26 00:00:00').getTime()
        }
      }
    },
    {
      field: 'isTransfer',
      type: 'select',
      label: '排除转移',
      options: [
        {title: '是', value: ''},
        {title: '否', value: '1'}
      ]
    },
    {
      field: 'custAlreadyDeleted',
      type: 'select',
      label: '删除说明',
      clearable: true,
      filterable: true,
      options: [
        {title: '全部', value: ''},
        {title: '客户先删我们', value: 1},
        {title: '主动删除客户', value: 0},
        {title: '历史数据不明', value: 2}
      ]
    }
  ]
}
